/* eslint-disable */
import React, { useState, useEffect } from "react";
import Clients from "./Clients";
import AddClient from "./AddClient";
import { getClientsByUser } from "../../actions/clientActions";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import NoData from "../svgIcons/NoData";
import Spinner from "../Spinner/Spinner";
import { useDebounce } from "../../utils/utils";
import SearchRoundedIcon from "@material-ui/icons/SearchRounded";
import { Container } from "@material-ui/core";

const inputStyle = {
  padding: "0.75rem 0.75rem",
  width: "50%",
  fontSize: "0.8rem",
  lineHeight: 1.25,
  color: "#55595c",
  backgroundColor: "#fff",
  backgroundImage: "none",
  backgroundClip: "padding-box",
  borderTop: "0",
  borderRight: "0",
  borderBottom: "1px solid #eee",
  borderLeft: "0",
  borderRadius: "3px",
  transition: "all 0.25s cubic-bezier(0.4, 0, 1, 1)",
};
const iconStyle = {
  fontSize: "1.5rem",
  marginRight: "8px",
  position: "absolute",
  right: "50%",
  top: 10,
};

const filterStyle = {
  position: "relative",
  display: "flex",
  justifyContent: "space-between",
  flexWrap: "wrap",
  width: "100%",
  paddingBottom: "50px",
};
const ClientList = () => {
  const history = useHistory();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [currentId, setCurrentId] = useState(null);
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("profile"));
  const { clients, totalPages } = useSelector((state) => state.clients);
  console.log(clients);
  const isLoading = useSelector((state) => state.clients.isLoading);
  const [pageSize, setPageSize] = useState(5);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const searchTerm = useDebounce(search, 500);
  // const clients = []

  // useEffect(() => {
  // }, [currentId, dispatch]);

  //     useEffect(() => {
  //         dispatch(getClients(1));
  //         // dispatch(getClientsByUser({userId : user?.result?._id}));
  //         // dispatch(getClientsByUser({ search :user?.result?._id, tags: tags.join(',') }));
  //     },[location]
  // )

  useEffect(() => {
    dispatch(
      getClientsByUser({
        userId:
          user?.result?.role === "assistant"
            ? user?.result?.userId[0]
            : user?.result?._id || user.result.googleId,
        search: searchTerm,
        page: page,
        pageSize: pageSize,
      })
    );
  }, [location, dispatch, searchTerm, page, pageSize]);

  if (!user) {
    history.push("/login");
  }

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          paddingTop: "20px",
        }}
      >
        <Container style={{ width: "85%" }}>
          <div
            style={{
              position: "relative",
              display: "flex",
              justifyContent: "space-between",
              flexWrap: "wrap",
              width: "100%",
              paddingTop: "6.5%",
            }}
          >
            <input
              placeholder="Search client name... "
              name="search"
              type="text"
              style={inputStyle}
              value={search}
              autoFocus
              onChange={(e) => setSearch(e.target.value)}
            />
            <SearchRoundedIcon
              style={{
                fontSize: "1.5rem",
                marginRight: "8px",
                position: "absolute",
                right: "50%",
                top: 90,
              }}
            />
          </div>
          <Spinner />
        </Container>
      </div>
    );
  }

  if (clients.length === 0) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          paddingTop: "20px",
          margin: "80px",
        }}
      >
        <Container style={{ width: "85%" }}>
          <div style={filterStyle}>
            <input
              placeholder="Search client name... "
              name="search"
              type="text"
              style={inputStyle}
              value={search}
              autoFocus
              onChange={(e) => setSearch(e.target.value)}
            />
            <SearchRoundedIcon style={iconStyle} />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <NoData />
            <p style={{ padding: "40px", color: "gray", textAlign: "center" }}>
              No customers yet. Click the plus icon to add customer
            </p>
          </div>
        </Container>
      </div>
    );
  }

  return (
    <div>
      <AddClient
        open={open}
        setOpen={setOpen}
        currentId={currentId}
        setCurrentId={setCurrentId}
      />
      <Clients
        open={open}
        setOpen={setOpen}
        currentId={currentId}
        setCurrentId={setCurrentId}
        clients={clients}
        search={search}
        totalPages={totalPages}
        setSearch={setSearch}
        page={page}
        setPage={setPage}
        pageSize={pageSize}
        setPageSize={setPageSize}
      />
    </div>
  );
};

export default ClientList;
